import { resourceAllocationTypesEnum } from '@linearb/linjs-common';
import { MAIN_UI_TYPES } from '../../resource_types';
import useResourceTypes from '../../useResourceTypes';
import _ from 'lodash';
import { useCallback, useMemo } from 'react';
import useIsTreeHierarchyEnabled from '../../../state/filters/hooks/useIsTreeHierarchyEnabled';
import { ResourceAllocationFiltersContext } from '../../../state/filters/contexts';

const useResourceTypesGroupOptions = () => {
  const isTreeHierarchyEnabled = useIsTreeHierarchyEnabled(
    ResourceAllocationFiltersContext
  );
  const { resourceTypes, isLoading } = useResourceTypes();
  const resourceTypesInView = _.filter(resourceTypes, resourceType =>
    resourceType.displayIn?.includes(MAIN_UI_TYPES.AGGREGATED_TABLE)
  );

  const getOptionsByType = useCallback(
    type =>
      _.filter(
        resourceTypesInView,
        resourceType => type === 'all' || resourceType.type === type
      ).map(currType => ({
        value: currType.key,
        name: currType.name,
        resourceType: currType
      })),
    [resourceTypesInView]
  );

  const groupsList = useMemo(() => {
    const groupsConfig = isTreeHierarchyEnabled
      ? [
          { type: resourceAllocationTypesEnum.PROJECT, max: 1 },
          { type: resourceAllocationTypesEnum.DYNAMIC_ISSUE_TYPE, max: 2 },
          { type: resourceAllocationTypesEnum.CUSTOM_FIELD, max: 1 },
          { type: resourceAllocationTypesEnum.LABEL, max: 1 }
        ]
      : [{ max: 5, type: 'all' }];

    const groups = groupsConfig.map(({ type, max }) => ({
      options: getOptionsByType(type),
      max,
      type
    }));

    return groups;
  }, [resourceTypesInView, getOptionsByType]);

  return { groupsList, isLoading };
};

export default useResourceTypesGroupOptions;
